import React, { useEffect, useState } from 'react';
import { apiRequest } from '../../../service/apiRequest';
import {
    Table,
    Button,
    Flex,
    Breadcrumb,
    Form,
    message,
    Popconfirm,
    Space,
    Pagination,
    Switch,
    TableProps,
    Select,
    DatePicker,
    Input,
    Modal,
    Card,
    List,
    Row,
    Col,
    Typography,
    Tooltip,
    Tag,
    Divider,
} from 'antd';
import { createStyles } from 'antd-style';
import { HomeOutlined, DeleteOutlined, EditOutlined, TruckOutlined, SnippetsOutlined, FileTextOutlined, TagOutlined, PrinterOutlined } from '@ant-design/icons';
import { theme } from 'antd';
import { showSuccess, showError } from '../../../components/errorHandler';
import type { PopconfirmProps, TableColumnsType } from 'antd';
import { useCurrentModule } from '../../../hooks/useCurrentModule';
import dayjs from 'dayjs';

import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import type { RangePickerProps } from 'antd/es/date-picker';
import { useSearchParams, useNavigate } from 'react-router-dom';





import { saveAs } from 'file-saver';

const { RangePicker } = DatePicker;
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

const { Option } = Select;
const { Text } = Typography;


const useStyle = createStyles(({ css }) => ({
    customTable: css`
    .ant-table {
      &-container {
        .ant-table-body,
        .ant-table-content {
          scrollbar-width: thin;
          scrollbar-color: #eaeaea transparent;
        }
      }
    }
  `,
}));

interface Sale {
    sale_id: number;
    sale_type: string;
    sale_category: string;
    sale_invoice_no: string;
    sale_date: string;
    sale_total: number;
    sale_is_shipping: 'Y' | 'N';
    sale_pincode: number;
    sale_city: string;
    sale_state: string;
    sale_address: string;
    customer_first_name: string;
    customer_last_name: string;
    customer_mobile_no: string;
    salesmen_names: string;
    sale_company_name: string;
    sale_items?: SaleItem[];
}
interface SaleItem {
    sd_id: number;
    sd_sale_type: 'job' | 'product';
    pn_name: string;
    variant_name: string;
    sd_qty: number;
    sd_sub_total: number;
    sd_unit: string;
    sd_item_group: string;
    product_name: string;
    tailor_first_name?: string;
    tailor_last_name?: string;
    [key: string]: any;
}

interface Sale {
    sale_id: number;
    sale_invoice_no: string;
    sale_items?: SaleItem[];
}
interface PaymentDetailItem {
    pd_id: number;
    pd_sale_id: string | number;
    pd_sale_transaction_id: string | null;
    pd_payment_mode: string | null;
    pd_all_total_amount: string | number;
    pd_payment_detail: string | null;
    pd_created_on: string;
}

interface ModalProps {
    open: boolean;
    onClose: () => void;
    sale: Sale;
}


interface clientItem {
    ledger_id: number;
    ledger_first_name: string;
    ledger_last_name: string;
    ledger_mobile_no: string;
    ledger_company_name: string;
    // ledger_company_gst_no: string;

    // Additional keys returned from your API
    reference_phone?: string;
    reference_name?: string;
    handover_phone?: string;
    handover_name?: string;
    invoice_category?: string;
    sales_employee?: string;


    ledger_gstin: string;
    active_cart: string;
    sale_id: string;
}

interface PaymentModalProps {
    open: boolean;
    onClose: () => void;
    paymentDetails: PaymentDetailItem[]; // required
}
const Billing: React.FC = () => {
    const navigate = useNavigate();
    const currentModule = useCurrentModule();

    const [searchParams, setSearchParams] = useSearchParams();

    const [sales, setSales] = useState<Sale[]>([]);
    const [filterType, setFilterType] = useState<string>('');
    const [filterDate, setFilterDate] = useState<string>('');
    const [searchName, setSearchName] = useState<string>('');
    const [searchMobile, setSearchMobile] = useState<string>('');
    const [searchInvoiceNo, setSearchInvoiceNo] = useState<string>('');
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    const [clientItems, setClientItems] = useState<clientItem[]>([]);
    const [paymentDetails, setPaymentDetails] =
        useState<PaymentDetailItem[]>([]);
    const [initialValues, setInitialValues] = useState<clientItem | null>(null);

    const [pagination, setPagination] = useState<{ current: number; pageSize: number; total: number }>({
        current: 1,
        pageSize: 10,
        total: 0,
    });

    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();


    const [selectedSale, setSelectedSale] = useState<Sale | null>(null);
    const [showJobModal, setShowJobModal] = useState(false);
    const [showProductModal, setShowProductModal] = useState(false);
    const [showPaymentModal, setShowPaymentModal] = useState(false);

    const handleViewJob = (sale: Sale) => {
        setSelectedSale(sale);
        setShowJobModal(true);
    };

    const handleViewSale = (sale: Sale) => {
        setSelectedSale(sale);
        setShowProductModal(true);
    };
    const handleViewPayment = (sale: Sale) => {
        fetchPaymentDetails(sale.sale_id);
    };


    const fetchSales = async (page = 1, limit = 10) => {
        try {
            const params = new URLSearchParams({
                page: page.toString(),
                limit: limit.toString(),
                sale_type: filterType,
                sale_date: filterDate,
                customer_name: searchName,
                mobile_no: searchMobile,
                invoice_no: searchInvoiceNo,
            });

            const response = await apiRequest<{ data: Sale[]; total: number }>({
                method: 'get',
                url: `get-all-billing?${params.toString()}`,
            });

            setSales(response.data);
            setPagination((prev) => ({
                ...prev,
                total: response.total,
                current: page,
                pageSize: limit,
            }));
        } catch {
            showError('Failed to fetch sales');
        }
    };

    const fetchPaymentDetails = async (
        sale_id: string | number | null) => {
        console.log("response.sale_id", sale_id)
        try {
            const s_id = sale_id;
            const response = await apiRequest<{
                sale_id: string;
                data: PaymentDetailItem | PaymentDetailItem[];
            }>({
                method: 'get',
                url: `/get-payment-details/${s_id}`,
            });
            const data = Array.isArray(response.data) ? response.data : (response.data ? [response.data] : []);
            setPaymentDetails(data);

            setShowPaymentModal(true);
            console.log("data", response.data);
            console.log("Updated payment item:", response.data);

        } catch {
            // showError('Failed to fetch vouchers');
        }
    };
    useEffect(() => {
        fetchSales();
    }, []);

    const groupBy = <T, K extends keyof T>(array: T[], key: K): Record<string, T[]> => {
        return array.reduce((result, item) => {
            const groupKey = item[key] as unknown as string;
            if (!result[groupKey]) result[groupKey] = [];
            result[groupKey].push(item);
            return result;
        }, {} as Record<string, T[]>);
    };

    const handleTableChange: TableProps<Sale>['onChange'] = (pagination, filters, sorter) => {
    };

    const columnsModal = [
        {
            title: 'Product Name',
            dataIndex: 'product_name',
            key: 'product_name',
        },
        {
            title: 'Quantity',
            dataIndex: 'sd_qty',
            key: 'sd_qty',
        },
        {
            title: 'Amount',
            dataIndex: 'sd_amount',
            key: 'sd_amount',
            render: (value: number | string | null) => {
                const amount = value === null || value === undefined || value === ''
                    ? 0
                    : Number(value);

                return `₹ ${amount.toFixed(2)}`;
            }
        },
        {
            title: 'Discount',
            dataIndex: 'sd_discount',
            key: 'sd_discount',
            render: (value: number | string | null) => {
                const amount = value === null || value === undefined || value === ''
                    ? 0
                    : Number(value);

                return `₹ ${amount.toFixed(2)}`;
            }
        },
        {
            title: 'Sub Total',
            dataIndex: 'sd_sub_total',
            key: 'sd_sub_total',
            render: (value: number | string | null) => {
                const amount = value === null || value === undefined || value === ''
                    ? 0
                    : Number(value);

                return `₹ ${amount.toFixed(2)}`;
            }
        },
    ];

    const columnsPaymentModal = [
        {
            title: 'Transaction ID',
            dataIndex: 'pd_sale_transaction_id',
            key: 'pd_sale_transaction_id',
            render: (value: string) => value || '-',
        },
        {
            title: 'Payment Mode',
            dataIndex: 'pd_payment_mode',
            key: 'pd_payment_mode',
            render: (value: string) => value || '-',
        },
        {
            title: 'Total Amount',
            dataIndex: 'pd_all_total_amount',
            key: 'pd_all_total_amount',
            render: (value: number | string | null) => {
                const amount = value === null || value === undefined || value === ''
                    ? 0
                    : Number(value);

                return `₹ ${amount.toFixed(2)}`;
            }
        },
        {
            title: 'Payment Details',
            dataIndex: 'pd_payment_detail',
            key: 'pd_payment_detail',
            render: (value: string | null) => value || '-',
        },
        {
            title: 'Created On',
            dataIndex: 'pd_created_on',
            key: 'pd_created_on',
            render: (value: string) => {
                const date = new Date(value);
                return isNaN(date.getTime()) ? '-' : date.toLocaleString();
            },
        },
    ];





    const onInvoiceDownload = async (saleId: number) => {
        try {
            const response = await apiRequest<Blob>({
                method: 'post',
                url: '/download-invoice',
                data: {
                    sale_id: [saleId], // Still an array
                },
                config: {
                    responseType: 'blob',
                },
            });

            const blob = new Blob([response], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `tax_invoice_${saleId}.pdf`);
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

            message.success("Download started.");
        } catch (error) {
            console.error("Invoice download error:", error);
            message.error("Failed to download invoice.");
        }
    };




    // transport
    const onInvoiceTransportDownload = async () => {
        if (!selectedRowKeys.length) {
            message.error("Please select a row to download its invoice Transport.");
            return;
        }

        if (selectedRowKeys.length > 1) {
            message.warning("Only the first selected row will be used.");
        }
        try {
            const response = await apiRequest<Blob>({
                method: 'post',
                url: '/download-invoice-transport',
                data: {
                    sale_id: [selectedRowKeys[0]],
                },
                config: {
                    responseType: 'blob',  // ✅ fix here
                },
            });

            const blob = new Blob([response], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `tax_invoice_transport.pdf`);
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

            message.success("Download started.");
        } catch (error) {
            console.error("Invoice Transport download error:", error);
            message.error("Failed to download Invoice Transport.");
        }
    };


    // job Tailor
    const onTailorJobDownload = async () => {
        if (!selectedRowKeys.length) {
            message.error("Please select a row to download its Tailor Job.");
            return;
        }

        if (selectedRowKeys.length > 1) {
            message.warning("Only the first selected row will be used.");
        }
        try {
            const response = await apiRequest<Blob>({
                method: 'post',
                url: '/download-tailor-job',
                data: {
                    sale_id: [selectedRowKeys[0]],
                },
                config: {
                    responseType: 'blob',  // ✅ fix here
                },
            });

            const blob = new Blob([response], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `tailor_job.pdf`);
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

            message.success("Download started.");
        } catch (error) {
            console.error("Tailor Job download error:", error);
            message.error("Failed to download Tailor Job.");
        }
    };


    // job slip
    const onJobslipDownload = async () => {
        if (!selectedRowKeys.length) {
            message.error("Please select a row to download its Job slip.");
            return;
        }

        if (selectedRowKeys.length > 1) {
            message.warning("Only the first selected row will be used.");
        }
        try {
            const response = await apiRequest<Blob>({
                method: 'post',
                url: '/download-job-slip',
                data: {
                    sale_id: [selectedRowKeys[0]],
                },
                config: {
                    responseType: 'blob',  // ✅ fix here
                },
            });

            const blob = new Blob([response], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `job_slip.pdf`);
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

            message.success("Download started.");
        } catch (error) {
            console.error("Job slip download error:", error);
            message.error("Failed to download Job slip.");
        }
    };


    // job Tag
    const onJobTagDownload = async () => {
        if (!selectedRowKeys.length) {
            message.error("Please select a row to download its Job Tag.");
            return;
        }

        if (selectedRowKeys.length > 1) {
            message.warning("Only the first selected row will be used.");
        }
        try {
            const response = await apiRequest<Blob>({
                method: 'post',
                url: '/download-job-tag',
                data: {
                    sale_id: [selectedRowKeys[0]],
                },
                config: {
                    responseType: 'blob',  // ✅ fix here
                },
            });

            const blob = new Blob([response], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `job_tag.pdf`);
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

            message.success("Download started.");
        } catch (error) {
            console.error("Job tag download error:", error);
            message.error("Failed to download Job tag.");
        }
    };

    const handleEditClick = (record: Sale) => {
        navigate(`/pos/${record.sale_id}`, {
            state: {
                isEditMode: true,
                // disableInputs: ['invoiceCategory', 'phone', 'firstName', 'lastName', 'company', 'gst', 'salesEmployee', 'selectedDate'], // Example input names
                disableInputs: [], // Example input names
            },
        });
    };



    const YourProductModalComponent: React.FC<ModalProps> = ({ open, onClose, sale }) => {
        const productItems = sale.sale_items?.filter(i => i.sd_sale_type === 'product') || [];





        return (
            <Modal
                open={open}
                title={`Product Items - Invoice: ${sale.sale_invoice_no}`}
                onCancel={onClose}
                footer={null}
                width={800}
            >
                <Table
                    dataSource={productItems}
                    columns={columnsModal}
                    rowKey="sd_id"
                    pagination={false}
                    scroll={{ y: 300 }}
                />
            </Modal>
        );
    };

    const PaymentModalComponent: React.FC<PaymentModalProps> = ({ open, onClose, paymentDetails }) => {
        // Use paymentDetails directly; default to empty array if undefined
        const paymentItems = paymentDetails || [];

        return (
            <Modal
                open={open}
                title="Payment Details"
                onCancel={onClose}
                footer={null}
                width={800}
            >
                <Table
                    dataSource={paymentItems}
                    columns={columnsPaymentModal}
                    rowKey="pd_id"
                    pagination={false}
                    scroll={{ y: 300 }}
                />
            </Modal>
        );
    };

    const YourJobModalComponent: React.FC<ModalProps> = ({ open, onClose, sale }) => {
        const jobItems = sale.sale_items?.filter(i => i.sd_sale_type === 'job') || [];

        // Group by sd_item_group
        const groupedItems = groupBy(jobItems, 'sd_item_group');

        return (
            <Modal
                open={open}
                title={`Job Items - Invoice: ${sale.sale_invoice_no}`}
                onCancel={onClose}
                footer={null}
                width={800}
            >
                {Object.entries(groupedItems).map(([group, items]) => {
                    // Assuming customer info is same for all items in the group — take from first item or sale object
                    const customerName = sale.customer_first_name + ' ' + sale.customer_last_name;
                    const customerMobile = sale.customer_mobile_no;

                    return (
                        <Card
                            key={group}
                            title={`Group: ${group}`}
                            style={{ marginBottom: 16 }}
                        >
                            <p><strong>Customer Name:</strong> {customerName}</p>
                            <p><strong>Customer Mobile:</strong> {customerMobile}</p>

                            <List
                                itemLayout="horizontal"
                                dataSource={items}
                                renderItem={item => (
                                    <List.Item key={item.sd_id}>
                                        <List.Item.Meta
                                            title={`Job No: ${item.sd_manual_job_no}`}
                                            description={
                                                <>
                                                    <div><strong>Tailor Name:</strong> {item.sd_tailor_name}</div>
                                                    <div><strong>Measurement:</strong> {item.sd_measurement}</div>
                                                    <div><strong>Fabric Issued:</strong> {item.sd_fabric_issued}</div>
                                                    {/* add more item fields here */}
                                                </>
                                            }
                                        />
                                    </List.Item>
                                )}
                            />
                        </Card>
                    );
                })}
            </Modal>
        );
    };


    const columns: TableColumnsType<Sale> = [
        {
            title: 'Sale Info',
            key: 'sale_info',

            width: 230,
            render: (_, record) => (
                <div>
                    <div><strong>Invoice:</strong> {record.sale_invoice_no}</div>
                    <div><strong>Date:</strong> {record.sale_date}</div>
                    <div><strong>Type:</strong> {record.sale_type}</div>
                    <div><strong>Category:</strong> {record.sale_category}</div>
                    {record.sale_category === "Invoice (B2B)" && record.sale_company_name && (
                        <div>
                            <strong>Company Name:</strong> {record.sale_company_name}
                        </div>
                    )}
                </div>
            ),
        },
        {
            title: 'Customer Details',
            key: 'customer_details',
            render: (_, record) => (
                <div>
                    <div><strong>Name:</strong>{record.customer_first_name + ' ' + record.customer_last_name}</div>
                    <div><strong>Mobile:</strong>{record.customer_mobile_no}</div>
                </div>
            ),
        },
        {
            title: 'Payment Details',
            dataIndex: 'payment_mode',
            key: 'payment_mode',
            render: (_, record) => (
                <Space direction="vertical" size={2}>
                    <Text strong style={{ fontSize: 15 }}>
                        ₹{Number(record.sale_total).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                    </Text>
                    <Button
                        size="small"
                        type="link"
                        style={{ padding: 0, height: 'auto' }}
                        onClick={() => handleViewPayment(record)}
                    >
                        View Payments
                    </Button>
                </Space>
            ),
        },

        {
            title: 'Sale Details',
            key: 'sale_details',
            width: 180,
            render: (_, record) => {
                const hasProduct = record.sale_items?.some(item => item.sd_sale_type === 'product');


                return (
                    <Space size="small" wrap>
                        {hasProduct && (
                            <Tag color="blue" style={{ cursor: 'pointer', margin: 0 }} onClick={() => handleViewSale(record)}>
                                Products
                            </Tag>
                        )}
                    </Space>
                );
            },
        },
        {
            title: 'Action',
            key: 'action',
            fixed: 'right',
            width: 120,
            align: 'center',
            render: (_, record) => (
                <Space size="small">
                    {/* {currentModule?.right_edit === 'Y' && (
                        <Tooltip title="Edit Invoice">
                            <Button
                                size="middle"
                                type="text"
                                style={{ color: '#1890ff', backgroundColor: '#e6f7ff' }}
                                icon={<EditOutlined />}
                                onClick={() => handleEditClick(record)}
                            />
                        </Tooltip>
                    )} */}

                    <Tooltip title="Print PDF">
                        <Button
                            size="middle"
                            type="primary"
                            style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
                            icon={<PrinterOutlined />}
                            onClick={() => onInvoiceDownload(record.sale_id)}
                        />
                    </Tooltip>
                </Space>
            ),
        },
    ];

    return (
        <div style={{ height: "calc(100vh - 145px)", display: "flex", flexDirection: "column", overflow: "hidden" }}>
            {/* Header Section: Breadcrumb + Filters */}
            <div style={{ padding: '0 16px 16px 16px' }}>
                <Row>
                    <Col span={24}>
                        <Breadcrumb style={{ display: 'inline-block', margin: '8px 0' }}>
                            <Breadcrumb.Item href="/">
                                <HomeOutlined />
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>View Billing</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                </Row>

                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Flex gap="small" wrap align="center">
                            <Select
                                placeholder="Sale Type"
                                style={{ width: 140 }}
                                onChange={(value) => setFilterType(value)}
                                allowClear
                            >
                                <Option value="Online">Online</Option>
                                <Option value="Store">Store</Option>
                            </Select>

                            <RangePicker
                                style={{ width: 260 }}
                                onChange={(dates: any) => {
                                    if (dates) {
                                        const start = dates[0].format('YYYY-MM-DD');
                                        const end = dates[1].format('YYYY-MM-DD');
                                        setFilterDate(`${start} - ${end}`);
                                    } else {
                                        setFilterDate('');
                                    }
                                }}
                                format="ddd - DD MMM YY"
                            />

                            <Input
                                placeholder="Customer Name"
                                onChange={(e) => setSearchName(e.target.value)}
                                style={{ width: 150 }}
                            />

                            <Input
                                placeholder="Mobile No"
                                onChange={(e) => setSearchMobile(e.target.value)}
                                style={{ width: 130 }}
                            />

                            <Input
                                placeholder="Invoice No."
                                onChange={(e) => setSearchInvoiceNo(e.target.value)}
                                style={{ width: 130 }}
                            />

                            <Button type="primary" onClick={() => fetchSales(1, pagination.pageSize)}>
                                Search
                            </Button>
                        </Flex>
                    </Col>
                </Row>
            </div>

            {/* Table Section: Flexed and Internal Scroll */}
            <div
                style={{
                    flex: 1,
                    background: colorBgContainer,
                    borderRadius: borderRadiusLG,
                    margin: '0 16px 16px 16px',
                    padding: '16px',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                }}
            >
                <Table<Sale>
                    columns={columns}
                    dataSource={sales}
                    tableLayout="fixed"
                    rowKey="sale_id"
                    pagination={false}
                    onChange={handleTableChange}
                    bordered
                    size="middle"
                    rowSelection={{
                        selectedRowKeys,
                        onChange: setSelectedRowKeys,
                        type: 'checkbox',
                        columnWidth: 40,
                    }}
                    scroll={{ x: 1400, y: 'calc(100vh - 420px)' }}
                    locale={{ emptyText: 'No record found' }}
                    style={{ flex: 1 }}
                />

                {/* Footer / Pagination Section */}
                <div style={{ marginTop: 16 }}>
                    <Flex justify="space-between" align="center">
                        <Text type="secondary">
                            Showing {(pagination.current - 1) * pagination.pageSize + 1}–
                            {Math.min(pagination.current * pagination.pageSize, pagination.total)} of {pagination.total}
                        </Text>
                        <Pagination
                            current={pagination.current}
                            pageSize={pagination.pageSize}
                            total={pagination.total}
                            onChange={(page, size) => fetchSales(page, size)}
                            showSizeChanger
                            size="small"
                        />
                    </Flex>
                </div>
            </div>

            {/* Modals */}
            {showProductModal && selectedSale && (
                <YourProductModalComponent
                    open={showProductModal}
                    onClose={() => setShowProductModal(false)}
                    sale={selectedSale}
                />
            )}

            {showPaymentModal && (
                <PaymentModalComponent
                    open={showPaymentModal}
                    onClose={() => setShowPaymentModal(false)}
                    paymentDetails={paymentDetails}
                />
            )}

            {showJobModal && selectedSale && (
                <YourJobModalComponent
                    open={showJobModal}
                    onClose={() => setShowJobModal(false)}
                    sale={selectedSale}
                />
            )}
        </div>
    );
};

export default Billing;